import { sortedTokensFor, buildRegExp } from '@corp/services/filter'
import { isBlank } from '@corp/helpers/object'
import { isString } from '@corp/helpers/string'

// Adds a colored span to the token matches inside the string.
export function highlightString (value: any, { query }: { query: string }) {
  if (isBlank(value)) return []
  if (!isString(value)) value = value.toString()
  const tokens = sortedTokensFor(query)
  let i = 0
  const renderedItems = []
  let queue: any[] = []

  const dequeue = () => {
    if (queue.length) {
      const text = queue.join('')
      renderedItems.push(<span>{text}</span>)
      queue = []
    }
  }

  while (i < value.length) {
    const token = tokens.find(token => buildRegExp(token).test(value.substr(i, token.length)))
    if (token) {
      dequeue()
      const text = value.substr(i, token.length)
      renderedItems.push(<span class="highlighted">{text}</span>)
      i += token.length
    }
    else {
      queue.push(value[i++])
    }
  }
  dequeue()

  return renderedItems
}
